export default __webpack_public_path__ + "static/media/P20_Tip_Box.42eb0119.svg";